import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/strategy/reveal")({
	beforeLoad: ({ search }) => {
		throw redirect({
			to: "/strategy",
			search: search as Record<string, unknown>,
			replace: true,
		});
	},
	component: () => null,
});
